export const ENCRYPTED_KEY_BASE64_MIN_SIZE = 64;
export const ENCRYPTED_KEY_BASE64_MAX_SIZE = 8096;
export const PUBLIC_KEY_BASE64_MIN_SIZE = 128;
export const PUBLIC_KEY_BASE64_MAX_SIZE = 2048;
export const AES_KEY_BASE64_MIN_SIZE = 24;
export const AES_KEY_BASE64_MAX_SIZE = 44;
export const SIGNED_ENTITY_BASE64_MIN_SIZE = 64;
export const SIGNED_ENTITY_BASE64_MAX_SIZE = 2048;
